import { render } from "./ProductionTimeView.vue?vue&type=template&id=3b8c55e6&scoped=true"
import script from "./ProductionTimeView.vue?vue&type=script&lang=js"
export * from "./ProductionTimeView.vue?vue&type=script&lang=js"

import "./ProductionTimeView.vue?vue&type=style&index=0&id=3b8c55e6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8c55e6"]])

export default __exports__